import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    limitCouponGoodsIds: null
  },
  mutations: {
    SET_LIMIT_COUPON_GOODS_IDS(state, data) {
      state.limitCouponGoodsIds = data;
    },
    CLEAR_LIMIT_COUPON_GOODS_IDS(state) {
      state.limitCouponGoodsIds = null;
    }
  },
  actions: {
    setLimitCouponGoodsIds({ commit }, data) {
      commit('SET_LIMIT_COUPON_GOODS_IDS', data);
    },
    clearLimitCouponGoodsIds({ commit }) {
      commit('CLEAR_LIMIT_COUPON_GOODS_IDS');
    }
  },
  getters: {
    getLimitCouponGoodsIds: (state) => state.limitCouponGoodsIds
  }
}); 